import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PaymentMethodEnum } from '@/types/common';
import { getImageSize } from '@/utils/style';
import { useTranslate } from '@/hooks/useTranslate';
import { getPaymentMethodBoxUrl, isCardPaymentMethod, shouldUseBeDisplayName } from '@/utils/paymentMethods';

export const PaymentMethodRow = ({ paymentMethod }: { paymentMethod: PaymentMethodEnum }) => {
  const { paymentMethodsAvailable } = useContext(CheckoutContext);
  const { t } = useTranslate();

  // Card methods that opt into the BE-supplied display name (see
  // `shouldUseBeDisplayName`) and every non-card method render the wire's
  // `paymentMethodDisplayName` as-is. The remaining card methods go through
  // i18n so publishers can override the label per locale.
  const getPaymentMethodText = () => {
    if (isCardPaymentMethod(paymentMethod) && !shouldUseBeDisplayName(paymentMethod)) {
      return t('creditCard');
    }
    return paymentMethodsAvailable.find((pm) => pm.paymentMethodName === paymentMethod)?.paymentMethodDisplayName ?? '';
  };

  return (
    <div className="flex flex-row items-center gap-2">
      <img className={getImageSize(paymentMethod)} src={getPaymentMethodBoxUrl(paymentMethod)} alt={paymentMethod} />
      <div className="text-sm color-base-foreground">{getPaymentMethodText()}</div>
    </div>
  );
};
